import { render, staticRenderFns } from "./shuxing-tree.vue?vue&type=template&id=4e8df4e9&scoped=true&"
import script from "./shuxing-tree.vue?vue&type=script&lang=ts&"
export * from "./shuxing-tree.vue?vue&type=script&lang=ts&"
import style0 from "./shuxing-tree.vue?vue&type=style&index=0&id=4e8df4e9&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e8df4e9",
  null
  
)

export default component.exports